/**

Coded by www.techhighway.ca

*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "context";

function DataTableHeadCell({ width="auto", children, sorted="none", align="left", column, ...rest }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <MDBox
      component="th"
      width={width}
      py={rest?.vertical_row_padding ? rest?.vertical_row_padding : 1.5}
      px={rest?.horizontal_row_padding ? rest?.horizontal_row_padding : 3}
      sx={({ palette: { light }, borders: { borderWidth } }) => ({
        borderBottom: `${borderWidth[1]} solid ${light.main}`,
        backgroundColor: `${rest?.th_bg_color}`,
      })}
    >
      <MDBox
        {...rest}
        onClick={(e) => {
          if (
            rest.is_sorted == "true" &&
            column.Header != "actions" &&
            column.Header != "Actions" &&
            typeof column.Header !== "object" &&
            typeof column.Header !== "function"
          ) {
            rest.onClick(e);
            rest.sort_column(column?.sorting_key ? column?.sorting_key : column?.id);
            rest.sort_column_value(column?.isSortedDesc ? "desc" : "asc");
          }
        }}
        position="relative"
        textAlign={align}
        color={darkMode ? "white" : "secondary"}
        opacity={1}
        sx={({ typography: { size, fontWeightBold } }) => ({
          fontSize: rest?.header_font_size ? rest?.header_font_size : "0.825rem",
          fontWeight: fontWeightBold,
          textTransform: "capitalize",
          cursor: sorted && "pointer",
          userSelect: sorted && "none",
        })}
      >
        {children}
        {sorted && typeof column.Header !== "function" && (
          <MDBox
            position="absolute"
            top={0}
            right={align !== "right" ? "16px" : 0}
            left={align === "right" ? "-5px" : "unset"}
            sx={({ typography: { size } }) => ({
              fontSize: size.lg,
            })}
          >
            <MDBox
              position="absolute"
              top={-6}
              color={sorted === "asce" ? "text" : "secondary"}
              opacity={sorted === "asce" ? 1 : 0.5}
            >
              <Icon>arrow_drop_up</Icon>
            </MDBox>
            <MDBox
              position="absolute"
              top={0}
              color={sorted === "desc" ? "text" : "secondary"}
              opacity={sorted === "desc" ? 1 : 0.5}
            >
              <Icon>arrow_drop_down</Icon>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
    </MDBox>
  );
}

// // Setting default values for the props of DataTableHeadCell
// DataTableHeadCell.defaultProps = {
//   width: "auto",
//   sorted: "none",
//   align: "left",
// };

// Typechecking props for the DataTableHeadCell
DataTableHeadCell.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  sorted: PropTypes.oneOf([false, "none", "asce", "desc"]),
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableHeadCell;
